import { Subject } from 'rxjs/Subject';
import { ICompleterItem } from '../entities/completerItem.interface';

export abstract class CompleterService extends Subject<ICompleterItem[]> {
    abstract search(term: string): void;

    abstract cancel(): void;
}
